export default defineNuxtPlugin(() => {
  // Core Web Vitals tracking for SEO performance
  if (process.client && typeof window !== 'undefined') {
    // Lazy load web vitals
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Track Core Web Vitals
      getCLS(sendToAnalytics)
      getFID(sendToAnalytics)
      getFCP(sendToAnalytics)
      getLCP(sendToAnalytics)
      getTTFB(sendToAnalytics)
    }).catch(() => {
      // Fallback if web-vitals is not available
      console.warn('Web Vitals tracking not available')
    })
  }

  function sendToAnalytics(metric: any) {
    // Send metrics to analytics (Google Analytics, etc.)
    if (typeof gtag !== 'undefined') {
      gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_category: 'Web Vitals',
        event_label: metric.id,
        non_interaction: true,
      })
    }
    
    // Console log for development
    if (process.dev) {
      console.log('Web Vital:', metric.name, metric.value)
    }
  }
})